// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3hAey","footer":"ModalError_footer__375h6"};